/** Display face — Google Fonts Yeseva One (loaded in CreateHead) */
export const fontDisplay = '"Yeseva One", serif'

/** Body & UI — Google Fonts Montserrat (loaded in CreateHead) */
export const fontBody = "Montserrat, sans-serif"

export const fonts = {
  display: fontDisplay,
  body: fontBody,
}

export default fonts
